/**
 * Subconjunto estático de ícones no traço visual do Lucide.
 *
 * O mapa fechado evita baixar ou executar a biblioteca no documento público. Nomes desconhecidos
 * recebem um círculo neutro, sem jamais serem interpolados como markup.
 */
const ICONES: Readonly<Record<string, string>> = {
  activity: '<path d="M22 12h-4l-3 9L9 3l-3 9H2"/>',
  archive:
    '<rect width="20" height="5" x="2" y="3" rx="1"/><path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8M10 12h4"/>',
  'alert-triangle':
    '<path d="m21.7 18-8-14a2 2 0 0 0-3.4 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.7-3Z"/><path d="M12 9v4M12 17h.01"/>',
  'arrow-left-right': '<path d="M8 3 4 7l4 4M4 7h16M16 21l4-4-4-4M20 17H4"/>',
  'arrow-right': '<path d="M5 12h14M13 6l6 6-6 6"/>',
  'badge-check':
    '<path d="M3.9 8.5a2 2 0 0 1 0-3l1.6-1.4a2 2 0 0 1 3-.1l.2.2a2 2 0 0 0 2.6 0l.2-.2a2 2 0 0 1 3 .1l1.6 1.4a2 2 0 0 1 0 3l-.2.2a2 2 0 0 0 0 2.6l.2.2a2 2 0 0 1 0 3l-1.6 1.4a2 2 0 0 1-3 .1l-.2-.2a2 2 0 0 0-2.6 0l-.2.2a2 2 0 0 1-3-.1l-1.6-1.4a2 2 0 0 1 0-3l.2-.2a2 2 0 0 0 0-2.6Z"/><path d="m9 12 2 2 4-4"/>',
  'badge-percent': '<circle cx="12" cy="12" r="9"/><path d="m9 15 6-6M9.5 9h.01M14.5 15h.01"/>',
  'bar-chart-3': '<path d="M3 3v18h18M8 17V9M13 17V5M18 17v-3"/>',
  'calendar-clock':
    '<path d="M21 12.8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h7M16 2v4M8 2v4M3 10h18"/><circle cx="18" cy="18" r="4"/><path d="M18 16v2l1 1"/>',
  check: '<path d="m20 6-11 11-5-5"/>',
  'check-circle-2': '<circle cx="12" cy="12" r="9"/><path d="m8 12 3 3 5-6"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  cloud: '<path d="M17.5 19H6a4 4 0 0 1-.5-8A6 6 0 0 1 17 9a5 5 0 0 1 .5 10Z"/>',
  database:
    '<ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v7c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 12v7c0 1.7 3.6 3 8 3s8-1.3 8-3v-7"/>',
  'database-backup':
    '<ellipse cx="11" cy="5" rx="7" ry="3"/><path d="M4 5v6c0 1.7 3.1 3 7 3M4 11v6c0 1.7 3.1 3 7 3M18 15v6M15 18h6"/>',
  'file-signature':
    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><path d="M14 2v6h6M8 16c1-2 2-2 3 0s2 2 5-1"/>',
  'file-text':
    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><path d="M14 2v6h6M8 13h8M8 17h8M8 9h2"/>',
  gauge: '<path d="M20 19a8 8 0 1 0-16 0M12 13l3-3"/><path d="M12 19h.01"/>',
  gift: '<rect width="18" height="14" x="3" y="8" rx="2"/><path d="M12 8v14M3 12h18M7.5 8C5 8 4 6.5 4 5.3 4 4 5 3 6.3 3 8.5 3 12 8 12 8M16.5 8C19 8 20 6.5 20 5.3 20 4 19 3 17.7 3 15.5 3 12 8 12 8"/>',
  globe:
    '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18"/>',
  'graduation-cap': '<path d="m2 10 10-5 10 5-10 5Z"/><path d="M6 12v5c3 2 9 2 12 0v-5M22 10v6"/>',
  'hand-coins':
    '<path d="M11 15h2a2 2 0 1 0 0-4H9c-.6 0-1.2.2-1.6.7L3 16"/><path d="m7 20 1.6-1.4c.4-.4 1-.6 1.6-.6H16c1.1 0 2.1-.4 2.8-1.2L22 13.5a2 2 0 0 0-3-2.6l-3 2.8M2 15l5 5"/><circle cx="16" cy="5" r="3"/>',
  'hard-drive': '<rect width="20" height="14" x="2" y="5" rx="2"/><path d="M6 15h.01M10 15h.01"/>',
  headset:
    '<path d="M4 14a8 8 0 0 1 16 0"/><path d="M18 19c0 1.7-1.3 3-3 3h-3M4 14v3a2 2 0 0 0 2 2h1v-7H6a2 2 0 0 0-2 2ZM20 14v3a2 2 0 0 1-2 2h-1v-7h1a2 2 0 0 1 2 2Z"/>',
  history: '<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5M12 7v5l3 2"/>',
  'key-round': '<circle cx="8" cy="15" r="4"/><path d="m11 12 8-8M15 8l2 2M17 6l2 2"/>',
  layers: '<path d="m12 2 9 5-9 5-9-5Z"/><path d="m3 12 9 5 9-5M3 17l9 5 9-5"/>',
  'life-buoy':
    '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/><path d="m5.6 5.6 4.3 4.3M14.1 14.1l4.3 4.3M18.4 5.6l-4.3 4.3M9.9 14.1l-4.3 4.3"/>',
  link: '<path d="M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1.1 1.1M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1.1-1.1"/>',
  lock: '<rect width="16" height="12" x="4" y="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>',
  mail: '<rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-10 6L2 7"/>',
  'map-pin':
    '<path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2"/>',
  'maximize-2': '<path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>',
  'message-circle':
    '<path d="M21 11.5a8.5 8.5 0 0 1-9 8.5 9 9 0 0 1-4-.9L3 21l1.9-5a9 9 0 1 1 16.1-4.5Z"/>',
  monitor: '<rect width="20" height="14" x="2" y="3" rx="2"/><path d="M8 21h8M12 17v4"/>',
  phone:
    '<path d="M22 16.9v3a2 2 0 0 1-2.2 2 20 20 0 0 1-8.7-3.1 20 20 0 0 1-6.1-6.1A20 20 0 0 1 2 4a2 2 0 0 1 2-2.2h3a2 2 0 0 1 2 1.7l.5 3a2 2 0 0 1-.6 1.8L7.6 9.6a16 16 0 0 0 6.1 6.1l1.3-1.3a2 2 0 0 1 1.8-.6l3 .5a2 2 0 0 1 1.7 2Z"/>',
  play: '<path d="m7 4 13 8-13 8Z"/>',
  printer:
    '<path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect width="12" height="8" x="6" y="14"/>',
  receipt:
    '<path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"/><path d="M16 8h-6M16 12h-6M13 16h-3"/>',
  scale:
    '<path d="m16 16 3-8 3 8a5 5 0 0 1-6 0ZM2 16l3-8 3 8a5 5 0 0 1-6 0ZM7 21h10M12 3v18M3 7h18"/>',
  'scroll-text':
    '<path d="M8 21h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H8"/><path d="M8 3a2 2 0 0 0-2 2v14a2 2 0 0 1-4 0v-2h4M11 7h7M11 11h7M11 15h5"/>',
  shield: '<path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3Z"/>',
  'shield-check':
    '<path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3Z"/><path d="m9 12 2 2 4-4"/>',
  star: '<path d="m12 2 3 6 7 .9-5 4.8 1.4 6.8L12 17l-6.4 3.5L7 13.7 2 8.9 9 8Z"/>',
  tags: '<path d="M9 5H2v7l9 9 7-7Z"/><path d="M16 3h6v6l-8 8M6 9h.01"/>',
  target:
    '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/>',
  ticket:
    '<path d="M2 9a3 3 0 0 0 0 6v3h20v-3a3 3 0 0 0 0-6V6H2Z"/><path d="M13 6v2M13 16v2M13 11v2"/>',
  'trending-down': '<path d="m3 7 6 6 4-4 8 8M15 17h6v-6"/>',
  unplug: '<path d="m19 5 3-3M2 22l3-3M6 8l-3 3 10 10 3-3M8 6l2-2M12 10l2-2"/>',
  users:
    '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8"/>',
  wallet:
    '<path d="M20 7V5a2 2 0 0 0-2-2H5a3 3 0 0 0 0 6h15v12H5a3 3 0 0 1-3-3V6"/><path d="M16 13h2"/>',
  wifi: '<path d="M5 12.6a10 10 0 0 1 14 0M2 9a15 15 0 0 1 20 0M8.5 16.2a5 5 0 0 1 7 0M12 20h.01"/>',
  x: '<path d="M18 6 6 18M6 6l12 12"/>',
  'x-circle': '<circle cx="12" cy="12" r="9"/><path d="m15 9-6 6M9 9l6 6"/>',
};

const ICONE_PADRAO = '<circle cx="12" cy="12" r="9"/>';

export function iconeEstatico(nome: string, classe: string): string {
  const desenho = ICONES[nome] ?? ICONE_PADRAO;
  return `<svg class="${classe}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${desenho}</svg>`;
}
